'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../../../node_modules/classnames/index.js');
var Navbar = require('../../Navbar.js');
var NavList = require('../DesktopList/NavList.js');
var NavBrand = require('../../components/NavBrand/NavBrand.js');
var NavToggle = require('../../components/NavToggle/NavToggle.js');
require('./DesktopMenu.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var DesktopMenu = function (props) {
    var _a = Navbar.useNavbarContext(), finalMenu = _a.finalMenu, activeLinks = _a.activeLinks;
    var _b = React.useState(null), activeItem = _b[0], setActiveItem = _b[1];
    var _c = props.isOffcanvasOpen, isOffcanvasOpen = _c === void 0 ? false : _c, onClick = props.onClick, isDesktop = props.isDesktop;
    return (React__default['default'].createElement("div", { className: index['default']('dm-root', isOffcanvasOpen ? 'is-open' : ''), onMouseLeave: function () {
            setActiveItem(undefined);
        } },
        React__default['default'].createElement("div", { className: 'dm-root-header' },
            React__default['default'].createElement(NavToggle.NavToggle, { onClick: onClick, isOffcanvasOpen: isOffcanvasOpen }),
            React__default['default'].createElement(NavBrand.NavBrand, null)),
        React__default['default'].createElement("div", { className: 'dm-root-body' },
            React__default['default'].createElement("ul", { className: 'ul_parent' }, finalMenu.map(function (item) { return (React__default['default'].createElement(NavList.NavList, { level: 0, key: item.title, item: item, onMouseOver: function () {
                    isDesktop
                        ? setActiveItem(item)
                        : setTimeout(function () {
                            setActiveItem(item);
                        }, 1);
                }, onMouseLeave: function () {
                    setActiveItem(undefined);
                }, isDesktop: isDesktop, isSelected: (activeItem && activeItem.title === item.title) ||
                    activeLinks.includes(item.link) })); })))));
};

exports.DesktopMenu = DesktopMenu;
//# sourceMappingURL=DesktopMenu.js.map
